export const apiBaseUrl = import.meta.env.API_URL
export const env = import.meta.env
export const IS_DEVELOPMENT = env.DEV
export const SENTRY_DSN = env.VITE_SENTRY_DSN
export const SENTRY_RELEASE = env.VITE_SENTRY_RELEASE || env.PACKAGE_VERSION
export const SENTRY_ENV = env.VITE_SENTRY_ENV
